import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import backend from 'utils/backend';

const WorkflowSync = (props) => {
  const {
    user,
    automationsLoadAutomations,
    playbooksLoadData,
    skillsLoadSkills,
  } = props;

  React.useEffect(() => {
    const loadWorkflowData = async () => {
      try {
        const result = await backend.workflow.getAll();

        automationsLoadAutomations(result?.taskRules || []);

        playbooksLoadData(result?.playbooks || []);

        skillsLoadSkills(result?.skills || []);
      } catch (error) {
        console.error('Failed to sync workflow data', error);
      }
    };

    if (user?.userRn) {
      loadWorkflowData();
    }
  }, [user]);

  return null;
};

WorkflowSync.propTypes = {
  user: PropTypes.object,
  automations: PropTypes.object.isRequired,
  playbooks: PropTypes.object.isRequired,
  skills: PropTypes.object.isRequired,
  automationsLoadAutomations: PropTypes.func.isRequired,
  playbooksLoadData: PropTypes.func.isRequired,
  skillsLoadSkills: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  automations: state.automations,
  playbooks: state.playbooks,
  skills: state.skills,
});

export default connect(mapStateToProps, dispatch)(React.memo(WorkflowSync));
